import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'
export function getAllBeefCircle(params) {
  return request({
    url: '/GetAllBeefCircle',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 740,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        KeyWords: params.KeyWord,
        SortOrder: params.SortOrder,
        Type: params.Type,
        IsOpen: params.openState
      }
    }
  })
}

export function getBeefCircleConversationRecordList(params) {
  return request({
    url: '/GetBeefCircleConversationRecordList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 740,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        KeyWords: params.KeyWord,
        SortOrder: params.SortOrder,
        CircleID: params.CircleID,
        Type: params.Type
      }
    }
  })
}

export function deleteCircleBackend(params) {
  return request({
    url: '/DeleteCircleBackend',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 741,
      MessageID: btcguid(),
      Data: {
        CircleID: params.CircleID
      }
    }
  })
}

export function deleteCircleLikeBackend(params) {
  return request({
    url: '/DeleteCircleLikeBackend',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 741,
      MessageID: btcguid(),
      Data: {
        CircleID: params.CircleID
      }
    }
  })
}

export function getBuyerOfferList(params) {
  return request({
    url: '/GetBuyerOfferList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 701,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        IsEntrustBtc: params.IsEntrustBtc,
        BuyerOfferState: params.BuyerOfferState
      }
    }
  })
}

export function getSellerOfferList(params) {
  return request({
    url: '/GetSellerOfferList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 702,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        IsEntrustBtc: params.IsEntrustBtc,
        SellerOfferState: params.SellerOfferState
      }
    }
  })
}

export function getBuyerOfferDetail(params) {
  return request({
    url: '/GetBuyerOfferDetail',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 703,
      MessageID: btcguid(),
      Data: {
        BuyerOfferID: params
      }
    }
  })
}

export function getSellerOfferDetail(params) {
  return request({
    url: '/GetSellerOfferDetail',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 704,
      MessageID: btcguid(),
      Data: {
        SellerOfferID: params
      }
    }
  })
}

export function updateBuyerOffer(params) {
  return request({
    url: '/UpdateBuyerOffer',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 705,
      MessageID: btcguid(),
      Data: {
        Flag: params.Flag,
        Reason: params.Reason,
        BuyerOfferID: params.OfferID,
        BuyerOfferState: params.OfferState
      }
    }
  })
}

export function updateSellerOffer(params) {
  return request({
    url: '/UpdateSellerOffer',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 706,
      MessageID: btcguid(),
      Data: {
        Flag: params.Flag,
        Reason: params.Reason,
        SellerOfferID: params.OfferID,
        SellerOfferState: params.OfferState
      }
    }
  })
}

export function getSellerOfferMatchList(params) {
  return request({
    url: '/GetSellerOfferMatchList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 707,
      MessageID: btcguid(),
      Data: {
        MatchType: 2,
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        SellerOfferID: params.SellerOfferID
      }
    }
  })
}

export function matchEntrustBtcOffer(params) {
  return request({
    url: '/MatchEntrustBtcOffer',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 708,
      MessageID: btcguid(),
      Data: {
        BuyerOfferID: params.BuyerOfferID,
        SellerOfferID: params.SellerOfferID
      }
    }
  })
}

export function identityValidate(params) {
  return request({
    url: '/IdentityValidate',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 709,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID,
        Role: params.Role
      }
    }
  })
}

export function getOrderAppendix(params) {
  return request({
    url: '/GetOrderAppendix',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 710,
      MessageID: btcguid(),
      Data: {
        OfferID: params.OfferID,
        OfferType: params.OfferType
      }
    }
  })
}

// 新交易接口
export function getBackendBuyerOffers(params) {
  return request({
    url: '/GetBackendBuyerOffers',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 711,
      MessageID: btcguid(),
      Data: {
        OfferType: params.OfferType,
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Keyword: params.Keyword,
        GoodsType: params.GoodsType,
        FilterType: params.FilterType
      }
    }
  })
}

export function offerSmartPush(params) {
  return request({
    url: '/OfferSmartPush',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 712,
      MessageID: btcguid(),
      Data: {
        OfferID: params.OfferID,
        Origin: params.Origin,
        Cuts: params.Cuts
      }
    }
  })
}

export function offerBtcPush(params) {
  return request({
    url: '/OfferBtcPush',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 713,
      MessageID: btcguid(),
      Data: {
        OfferID: params.OfferID,
        Origin: params.Origin,
        Cuts: params.Cuts,
        Quantity: params.Quantity,
        Price: params.Price,
        Destination: params.Destination,
        PlantNo: params.PlantNo,
        Grade: params.Grade,
        ExpireDate: params.ExpireDate,
        OfferType: '_sell',
        UserID: params.UserID
      }
    }
  })
}

export function getImporterExporter(params) {
  return request({
    url: '/GetImporterExporter',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 714,
      MessageID: btcguid(),
      Data: {
        CompanyRole: params.CompanyRole
      }
    }
  })
}

export function getCompanyRoleInfo(params) {
  return request({
    url: '/GetCompanyRoleInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 715,
      MessageID: btcguid(),
      Data: {
        PageNum: params.pageNum,
        PageSize: params.pageSize,
        KeyWord: params.KeyWord,
        CompanyRole: params.CompanyRole
      }
    }
  })
}

export function sendAssemblyOffer(params) {
  return request({
    url: '/SendAssemblyOffer',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 716,
      MessageID: btcguid(),
      Data: {
        Origin: params.Origin,
        Cuts: params.Cuts,
        Quantity: params.Quantity,
        Price: params.Price,
        Destination: params.Destination,
        ExpireDate: params.ExpireDate,
        ShippingDate: params.ShippingDate,
        Port: params.Port,
        OfferType: params.OfferType,
        GoodsType: params.GoodsType,
        UserID: params.UserID,
        BuyerOffers: params.BuyerOffers,
        Grade: params.Grade,
        PlantNo: params.PlantNo,
        Note: params.Note
      }
    }
  })
}

export function sendFuturesAssemblyOffer(params) {
  return request({
    url: '/SendFuturesAssemblyOffer',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 717,
      MessageID: btcguid(),
      Data: {
        Origin: params.Origin,
        Cuts: params.Cuts,
        Quantity: params.Quantity,
        Price: params.Price,
        Destination: params.Destination,
        ExpireDate: params.ExpireDate,
        ShippingDate: params.ShippingDate,
        Port: params.Port,
        OfferType: params.OfferType,
        GoodsType: params.GoodsType,
        UserID: params.UserID,
        BuyerOffers: params.BuyerOffers,
        SellerUserIDs: params.SellerUserIDs
      }
    }
  })
}

export function getAssemblyOffer(params) {
  return request({
    url: '/GetAssemblyOffer',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 718,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        GoodsType: params.GoodsType,
        Keyword: params.Keyword
      }
    }
  })
}

export function getExporterState(params) {
  return request({
    url: '/GetExporterState',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 719,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        OfferID: params.OfferID,
        Type: params.Type
      }
    }
  })
}

export function getImporterState(params) {
  return request({
    url: '/GetImporterState',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 720,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        OfferID: params.OfferID
      }
    }
  })
}

export function sendCounterOffer(params) {
  return request({
    url: '/SendCounterOffer',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 721,
      MessageID: btcguid(),
      Data: {
        OfferID: params.OfferID,
        FinalPrice: params.FinalPrice,
        FinalQuantity: params.FinalQuantity,
        ExpireDate: params.ExpireDate
      }
    }
  })
}

export function sendCounterToExporter(params) {
  return request({
    url: '/SendCounterToExporter',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 722,
      MessageID: btcguid(),
      Data: {
        OfferID: params.OfferID,
        SellerUserIDs: params.SellerUserIDs,
        FinalPrice: params.FinalPrice,
        FinalQuantity: params.FinalQuantity
      }
    }
  })
}

export function getSpotAsmOfferBuyerState(params) {
  return request({
    url: '/GetSpotAsmOfferBuyerState',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 723,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        OfferID: params.OfferID
      }
    }
  })
}

export function getOfferNotes(params) {
  return request({
    url: '/GetOfferNotes',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 724,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        OfferID: params.OfferID
      }
    }
  })
}

export function addOfferNote(params) {
  return request({
    url: '/AddOfferNote',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 725,
      MessageID: btcguid(),
      Data: {
        ContactWay: params.ContactWay,
        Content: params.Content,
        OfferID: params.OfferID,
        UserID: params.UserID
      }
    }
  })
}

export function updateOfferNature(params) {
  return request({
    url: '/UpdateOfferNature',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 726,
      MessageID: btcguid(),
      Data: {
        OfferID: params.OfferID,
        OfferNature: params.OfferNature
      }
    }
  })
}

export function importCompanyCustomsData(params) {
  const formData = new FormData()
  formData.append('MessageType', 727)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportCompanyCustomsData',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function getCompanyCustomsData(params) {
  return request({
    url: '/GetCompanyCustomsData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 728,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

export function getBackendCompanyCustomsData(params) {
  return request({
    url: '/GetBackendCompanyCustomsData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 729,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        KeyWord: params.KeyWord
      }
    }
  })
}

export function getGoodsSourceUpdateInfo(params) {
  return request({
    url: '/GetGoodsSourceUpdateInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 730,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        CompanyID: params.CompanyID
      }
    }
  })
}

export function importImporters(params) {
  const formData = new FormData()
  formData.append('MessageType', 731)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportImporters',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function getBackendImporters(params) {
  return request({
    url: '/GetBackendImporters',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 732,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

export function importTradingReference(params) {
  const formData = new FormData()
  formData.append('MessageType', 733)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportTradingReference',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function getBackendTradingReference(params) {
  return request({
    url: '/GetBackendTradingReference',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 734,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

export function getBackendEmail(params) {
  return request({
    url: '/GetBackendEmail',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 735,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Keywords: params.Keywords
      }
    }
  })
}

export function getBackendComments(params) {
  return request({
    url: '/GetBackendComments',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 736,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Keywords: params.Keywords
      }
    }
  })
}

export function updateBackendEmailState(params) {
  return request({
    url: '/UpdateBackendEmailState',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 737,
      MessageID: btcguid(),
      Data: {
        EmailID: params.EmailID,
        AuditState: params.AuditState
      }
    }
  })
}

export function updateEmailInfo(params) {
  return request({
    url: '/UpdateEmailInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 740,
      MessageID: btcguid(),
      Data: {
        EmailID: params.EmailID,
        Sender: params.Sender,
        Receiver: params.Receiver
      }
    }
  })
}

export function updateBackendComments(params) {
  return request({
    url: '/UpdateBackendComments',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 738,
      MessageID: btcguid(),
      Data: {
        CommentsID: params.CommentsID,
        AuditState: params.AuditState
      }
    }
  })
}

export function getUserCollection(params) {
  return request({
    url: '/GetUserCollection',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 739,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Keywords: params.Keywords
      }
    }
  })
}

export function addBuyerOffer(params) {
  return request({
    url: '/AddBuyerOffer',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 740,
      MessageID: btcguid(),
      Data: {
        Origin: params.Origin,
        Cuts: params.Cuts,
        PlantNo: params.PlantNo,
        Quantity: params.Quantity,
        Price: params.Price,
        Destination: params.Destination,
        // Port: params.Port,
        // ShippingDate: params.ShippingDate,
        Grade: params.Grade,
        WithBone: params.WithBone,
        Islamic: params.Islamic,
        FeedingWay: params.FeedingWay,
        // NeedBTCProxy: params.NeedBTCProxy,
        ExpireDate: params.ExpireDate,
        Note: params.Note,
        UserID: params.UserID,
        OfferType: '_buy',
        GoodsType: '_spot',
        // PurchaseType: params.PurchaseType,
        IsSync: params.IsSync,
        FillType: 1
      }
    }
  })
}

export function addRealTimeSource(params) {
  return request({
    url: '/AddRealTimeSource',
    method: 'post',
    data: {
      MessageType: 741,
      MessageID: btcguid(),
      Data: {
        Cuts: params.Cuts,
        Origin: params.Origin,
        PlantNo: params.PlantNo,
        Quantity: params.Quantity,
        UserID: params.UserID,
        Heart: params.Heart,
        IsSync: params.IsSync
      }
    }
  })
}

export function deleteCircleReviewBackend(params) {
  return request({
    url: '/DeleteCircleReviewBackend',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 740,
      MessageID: btcguid(),
      Data: {
        ReviewID: params.ReviewID
      }
    }
  })
}

export function clearCutsBrochureStatus(params) {
  return request({
    url: '/ClearCutsBrochureStatus',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 741,
      MessageID: btcguid(),
      Data: {
        BrochureID: params.BrochureID
      }
    }
  })
}

export function readBeefCircleReviews(params) {
  return request({
    url: '/ReadBeefCircleReviews',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 742,
      MessageID: btcguid(),
      Data: {
        CircleID: params.CircleID,
        KeyWords: params.KeyWords
      }
    }
  })
}

export function getAllBeefChat(params) {
  return request({
    url: '/GetAllBeefChat',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 743,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        KeyWords: params.KeyWord,
        UserID: params.FromUserID,
        FriendUserID: params.ToUserID,
        IsAssistant: params.IsAssistant
      }
    }
  })
}

export function getBeefChatDetail(params) {
  return request({
    url: '/GetBeefChatDetail',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 744,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        KeyWords: params.KeyWord,
        UserID: params.FromUserID,
        FriendUserID: params.ToUserID,
        IsUpdateManageStatus: params.IsUpdate
      }
    }
  })
}

export function updateChatManageStatus(params) {
  return request({
    url: '/UpdateChatManageStatus',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 744,
      MessageID: btcguid(),
      Data: {
        ChatID: params.ChatID,
        ManageStatus: params.ManageStatus
      }
    }
  })
}

// 删除求购
export function deleteBackendBuyerOffers(params) {
  return request({
    url: '/DeleteBackendBuyerOffers',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 745,
      MessageID: btcguid(),
      Data: {
        OfferID: params.OfferID
      }
    }
  })
}

// 删除求购
export function topBeefCircle(params) {
  return request({
    url: '/TopBeefCircle',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 746,
      MessageID: btcguid(),
      Data: {
        CircleID: params.CircleID,
        IsTop: params.IsTop
      }
    }
  })
}

export function getChatUserDetail(params) {
  return request({
    url: '/GetChatUserDetail',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 747,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID
      }
    }
  })
}

export function PublishCircleBackEndApi(params) {
  return request({
    url: '/PublishCircleBackEnd',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 748,
      MessageID: btcguid(),
      Data: params
    }
  })
}

export function UploadCirclePictureBackEndApi(params) {
  const formData = new FormData()
  formData.append('MessageType', 2000000002)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  // formData.append('Type', params.Type)
  formData.append('UserID', params.UserID)
  return request({
    url: '/UploadCirclePictureBackEnd',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: formData
  })
}



// WEBPACK FOOTER //
// ./src/api/trade.js